import React from "react";

import RegressionInfo from "./RegressionInfo";
import BarChart from "../BarChart";
import { getType, types } from "../../Editor/itemTypes";
import EmptyBoard from "./EmptyBoard";
import PieChart from "../PieChart";

function FrequencyBoard({
  data,
  table,
  selectedLabels,
  choiceLabelsChecked,
  labelOpacity,
  setLabelOpacity,
  thumbnail,
  error,
  showValues,
  verticalBars,
  pieChart,
  sortDec,
}) {
  const freqAnalysis = window.frequencyAnalysis;
  const choiceLabel = choiceLabelsChecked[0] ?? { id: "", label: "" };

  const options = table
    .filter((data) => data.id === choiceLabel.id)
    .flatMap(({ options }) => options);

  const filteredData = data.flatMap((beep) =>
    beep.table.filter((row) => row.id === choiceLabel.id)
  );
  //console.log(filteredData);
  const values = filteredData.flatMap(({ scoreArr }) => {
    let row = [...options].fill(0);
    scoreArr.forEach((score) => {
      const index = options.findIndex((option) => score === option);
      if (index > -1) {
        row[index] = 1;
      }
    });
    return row;
  });
  //console.log(values)
  //console.log("FREQUENTIE ANALYSE");
  const N = filteredData.length;
  //console.log(N);

  const analysis = freqAnalysis(values, N);
  //console.log(analysis);

  const barchart = options.map((option, index) => {
    let dataObj = { name: option };
    // value
    const value = Math.round((analysis.MP[index + 1] + Number.EPSILON) * 100);

    // error bars
    const errorMin = !isNaN(analysis.DELTAPLOW[index + 1])
      ? analysis.DELTAPLOW[index + 1] * 100
      : 0;
    const errorMax = !isNaN(analysis.DELTAPUP[index + 1])
      ? analysis.DELTAPUP[index + 1] * 100
      : 0;
    const error = [errorMin, errorMax];

    const numberOfMeasurements = analysis.NM[index + 1];

    if (!isNaN(value)) {
      dataObj[`${choiceLabel.id}`] = value;
      dataObj[`${choiceLabel.id}$label`] = choiceLabel.label;
      dataObj[`${choiceLabel.id}$error`] = error;
      dataObj[`${choiceLabel.id}$numberOfMeasurements`] = numberOfMeasurements;
    }
    return dataObj;
  });
  //console.log(barchart);
  return (
    <React.Fragment>
      {pieChart ? (
        <PieChart
          data={barchart}
          quantitativeLabelsChecked={choiceLabelsChecked}
          height={!thumbnail ? 250 : 80}
          thumbnail={thumbnail}
          showValues={showValues}
          sortDec={sortDec}
        />
      ) : (
        <BarChart
          data={barchart}
          quantitativeLabelsChecked={choiceLabelsChecked}
          opacity={labelOpacity}
          height={!thumbnail ? 250 : 80}
          thumbnail={thumbnail}
          error={error}
          showValues={showValues}
          verticalBars={verticalBars}
          sortDec={sortDec}
        />
      )}
      {!thumbnail ? (
        <RegressionInfo category={choiceLabel.label} analyses={[]} />
      ) : null}
    </React.Fragment>
  );
}

export default FrequencyBoard;
